import { Children } from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Container = styled.header`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  width: 100%;
  position: sticky;
  top: 0;
  height: calc(var(--header-height) + 50px + 30px);
  z-index: 100;
  background-color: var(--color-white);
`;

export const Navbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: var(--header-height);
  padding: 0 12px;
`;

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

/* ── AI Button ─────────────────────────────────── */

export const AiWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const AiButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 12px;
  border-radius: var(--border-radius);
  background-color: var(--color-primary);
  cursor: pointer;
`;

export const AiBadge = styled.span`
  display: ${({ $hasNew }) => ($hasNew ? 'flex' : 'none')};
  position: absolute;
  top: -6px;
  right: -6px;
  align-items: center;
  justify-content: center;
  background-color: var(--color-black);
  color: var(--color-white);
  font-family: 'Geist', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 16px;
  padding: 0 5px;
  border-radius: var(--border-radius);
  white-space: nowrap;
`;

export const List = styled(motion.div).attrs(({ $isOpen, children }) => ({
  animate: $isOpen ? 'open' : 'close',
  variants: {
    open: {
      height: `calc(100% - var(--header-height))`,
      bottom: 0,
      overflow: 'auto',
      transition: {
        default: { duration: 0.5 },
        overflow: { delay: 0.5 + 0.1 * Children.count(children), duration: 0 },
        staggerChildren: 0.1,
      },
    },
    close: {
      height: 0,
      bottom: 'auto',
      transition: { duration: 0.05 },
      overflow: 'hidden',
    },
  },
  initial: 'close',
}))`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: var(--header-height);
  background: var(--color-white);
  z-index: 101;
  width: 100%;
`;
